var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { lighten } from "@mui/material";
import { COLORS, DEFAULT_SHADOW } from "../../../constants/colors";
import { CHIP_TYPE } from "./Chip";
export var baseChipStylesFn = function (_a) {
    var _b;
    var hideBgMobile = _a.hideBgMobile, breakpoints = _a.breakpoints, chipType = _a.chipType;
    return (_b = {
            color: COLORS.BLACK,
            backgroundColor: function (theme) {
                return chipType === CHIP_TYPE.WHITE
                    ? COLORS.WHITE
                    : lighten(theme.palette.primary.main, 0.88);
            },
            "&:hover": {
                backgroundColor: function (theme) {
                    return chipType === CHIP_TYPE.WHITE
                        ? lighten(theme.palette.primary.main, 0.96)
                        : lighten(theme.palette.primary.main, 0.84);
                }, // .16
            },
            "&:focus": {
                backgroundColor: function (theme) {
                    return chipType === CHIP_TYPE.WHITE
                        ? lighten(theme.palette.primary.main, 0.88)
                        : lighten(theme.palette.primary.main, 0.76);
                }, //  .24
            },
            "& > .MuiTouchRipple-root": {
                color: "primary.main",
            }
        },
        _b[breakpoints.down("sm")] = __assign(__assign({}, (hideBgMobile && { background: "none !important" })), (hideBgMobile && { boxShadow: "none !important" })),
        _b["&.Mui-disabled"] = {
            background: COLORS.LIGHT_GREY,
            opacity: 1,
            color: COLORS.P_DISABLED,
            ".MuiChip-deleteIcon": {
                color: COLORS.P_OUTLINE,
            },
        },
        _b["&.MuiChip-sizeSmall"] = {
            fontSize: "12px",
        },
        _b["&.MuiChip-sizeMedium"] = {
            fontSize: "14px",
        },
        _b[".MuiChip-icon"] = {
            width: "18px",
            height: "18px",
        },
        _b[".MuiChip-label"] = {
            lineHeight: "normal",
        },
        _b[".MuiChip-deleteIcon"] = {
            height: "18px",
            width: "18px",
            marginRight: "8px",
            color: "rgba(0, 0, 0, 0.5)",
        },
        _b["&.MuiChip-outlined"] = {
            backgroundColor: COLORS.WHITE,
            border: function (theme) { return "1px solid ".concat(theme.palette.primary.main); },
            "&:hover": {
                backgroundColor: function (theme) { return lighten(theme.palette.primary.main, 0.96); }, // .04
            },
            "&:focus": {
                backgroundColor: function (theme) { return lighten(theme.palette.primary.main, 0.88); }, // .12
            },
            "&.Mui-disabled": {
                background: COLORS.WHITE,
                border: "1px solid rgba(0, 0, 0, 0.12)",
                color: COLORS.P_DISABLED,
            },
        },
        _b);
};
export var chipTypeStyles = {
    defaultDragged: {
        "&.MuiChip-root": {
            backgroundColor: function (theme) {
                return lighten(theme.palette.primary.main, 0.8);
            },
            boxShadow: DEFAULT_SHADOW,
        },
    },
    outlinedDragged: {
        "&.MuiChip-root&.MuiChip-outlined": {
            backgroundColor: function (theme) {
                return lighten(theme.palette.primary.main, 0.92);
            },
            boxShadow: DEFAULT_SHADOW,
        },
    },
    whiteSelected: {
        "&.MuiChip-root": {
            backgroundColor: function (theme) {
                return lighten(theme.palette.primary.main, 0.92);
            },
        },
    },
    filterDefaultSelected: {
        "&.MuiChip-root": {
            border: function (theme) {
                return "1px solid ".concat(theme.palette.primary.main);
            },
            color: "primary.main",
            backgroundColor: function (theme) {
                return lighten(theme.palette.primary.main, 0.88);
            },
        },
    },
    filterDefaultSelectedWithIcon: {
        "&.MuiChip-root": {
            backgroundColor: function (theme) {
                return lighten(theme.palette.primary.main, 0.88);
            },
        },
    },
    inputDefaultSelected: {
        "&.MuiChip-root": {
            backgroundColor: function (theme) {
                return lighten(theme.palette.primary.main, 0.88);
            },
            color: COLORS.BLACK,
        },
    },
    inputDefaultSelectedWithIcon: {
        "&.MuiChip-root": {
            backgroundColor: function (theme) {
                return lighten(theme.palette.primary.main, 0.88);
            }, // .12
        },
    },
    choiceDefaultSelected: {
        "&.MuiChip-root": {
            backgroundColor: function (theme) {
                return lighten(theme.palette.primary.main, 0.76);
            },
            color: COLORS.BLACK,
        },
    },
    outlinedSelected: {
        "&.MuiChip-root&.MuiChip-outlined": {
            border: function (theme) {
                return "1px solid ".concat(theme.palette.primary.main);
            },
            color: COLORS.BLACK,
            backgroundColor: function (theme) {
                return lighten(theme.palette.primary.main, 0.92);
            },
        },
    },
};
